module.exports = __webpack_public_path__ + "img/pcb-shili1.3fe2553d.jpg";